import { Component,  inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ElectronicDemandComponent } from '../demanda/electronicDemand.component';
import { ElectronicNotificationComponent } from '../notificacion/Notificadas/electronicNotification.component';
import { ElectronicPromotionComponent } from '../promocion/electronicPromotion.component';
import { ExpedienteElectronicoComponent } from '../expedienteElectronico/expedienteElectronico.component';
import { NoNotificadasComponent } from '../notificacion/NoNotificadas/noNotificadas.component';
import { IncidenciasComponent } from '../incidencias/incidencias.component';
import { ReimpresionAcusesComponent } from '../reimpresionAcuses/reimpresionAcuses.component';
import { ServicioComponent } from '../servicio/servicio.component';
import { ConfigDiaInhabilComponent } from '../configDiaInhabil/configDiaInhabil.component';
import { altaUsuarioComponent } from '../altaUsuario/altaUsuario.component';
import { HelpComponent } from '../help/help.component';
import { ConsultaDemandaComponent } from '../demanda/consulta-demanda/consulta-demanda.component';

@Component({
    selector: 'oaj-container-itx',
    templateUrl: 'container.component.html',  
    imports: [ElectronicDemandComponent,ElectronicNotificationComponent,ElectronicPromotionComponent,
              ExpedienteElectronicoComponent,NoNotificadasComponent,IncidenciasComponent,ReimpresionAcusesComponent,
              ServicioComponent,ConfigDiaInhabilComponent, altaUsuarioComponent, HelpComponent, ConsultaDemandaComponent],
  })
export class ContainerComponent {

  private activatedRoute = inject(ActivatedRoute);
  Idpantalla!: number;

    constructor() {
          this.activatedRoute.params.subscribe(params => {
      this.Idpantalla = +params['Idpantalla'];      
    });
    }
}
